export default "__VITE_ASSET__B$DhtBqg__"